import { render, staticRenderFns } from "./NameChangeReportByComputerizedMedium.vue?vue&type=template&id=2eb56780&scoped=true&"
import script from "./NameChangeReportByComputerizedMedium.vue?vue&type=script&lang=js&"
export * from "./NameChangeReportByComputerizedMedium.vue?vue&type=script&lang=js&"
import style0 from "./NameChangeReportByComputerizedMedium.vue?vue&type=style&index=0&id=2eb56780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb56780",
  null
  
)

export default component.exports